<template>
    <div id="home">
        <p class="slogan">Full Stack Web Development.
            <br/>Simple. Elegant. Robust.
        </p>
        <div class="hero"></div>
    </div>  
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/config.scss";
#home{
    overflow: hidden;
    margin: 0px, 5rem;
}
.slogan{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44vh;
    font-size: 24px;
}

.hero{
    height: 44vh;
    background: url("../assets/Hero.jpg") no-repeat center bottom;
}
</style>